import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { LOGO_PINK } from "../../lib/data";

export const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [forgotSent, setForgotSent] = useState(false);
    const navigate = useNavigate();

    const forgot = async () => {
        if (!email) {
            toast.error("Enter your email above first.");
            return;
        }
        try {
            await api.post("/auth/forgot-password", { email });
            setForgotSent(true);
            toast.success("If an account exists for that email, a reset link is on its way.");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail));
        }
    };

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post("/auth/login", { email, password });
            localStorage.setItem("showtime_admin_token", res.data.token);
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="min-h-[100svh] bg-ink tent-stripes flex items-center justify-center px-5">
            <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-white rounded-3xl p-8">
                <img src={LOGO_PINK} alt="Showtime Carnival Co." className="h-16 w-auto mx-auto mb-6" />
                <h1 className="font-oswald uppercase text-2xl text-center mb-6">Backstage Login</h1>
                <label htmlFor="ad-email" className="block text-[11px] font-bold tracking-[0.25em] uppercase text-zinc-500 mb-2">Email</label>
                <input
                    id="ad-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="w-full rounded-2xl border border-zinc-300 px-5 py-3.5 text-sm outline-none focus:ring-2 focus:ring-pink mb-4"
                    data-testid="admin-email-input"
                />
                <label htmlFor="ad-pass" className="block text-[11px] font-bold tracking-[0.25em] uppercase text-zinc-500 mb-2">Password</label>
                <input
                    id="ad-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                    className="w-full rounded-2xl border border-zinc-300 px-5 py-3.5 text-sm outline-none focus:ring-2 focus:ring-pink mb-6"
                    data-testid="admin-password-input"
                />
                <button
                    type="submit" disabled={loading}
                    data-testid="admin-login-button"
                    className="w-full rounded-full bg-pink py-4 font-oswald uppercase tracking-widest text-ink hover:bg-ink hover:text-white transition-colors disabled:opacity-50"
                >
                    {loading ? "Checking..." : "Enter Backstage"}
                </button>
                <p className="text-center mt-5">
                    <button type="button" onClick={forgot} disabled={forgotSent} data-testid="admin-forgot-password" className="text-xs font-bold uppercase tracking-widest text-zinc-500 hover:text-pink-dark disabled:opacity-50">
                        {forgotSent ? "Reset link sent if the account exists" : "Forgot Password?"}
                    </button>
                </p>
            </form>
        </section>
    );
};
